export const allowList = ['login', 'register', 'register-result']; // no redirect whitelist
export const loginRoutePath = '/user/login';
export const defaultRoutePath = '/dashboard';
